module.exports = __webpack_public_path__ + "media/images/press_kit/default/email/top-small-429de91109ce197b62a485ce6c06c3a5.png";